import { getHighRewardTier, HIGH_REWARD_TIER } from './rewardConfig';
import HighRewardAdIcon from '../../assets/icons/punch/high-reward-ad-icon.svg';
import HighRewardCloseXIcon from '../../assets/icons/punch/high-reward-close-x.svg';
import HighRewardCrownIcon150 from '../../assets/icons/punch/crown.png';
import HighRewardCrownIcon100 from '../../assets/icons/punch/dia.png';
import HighRewardCrownIcon80 from '../../assets/icons/punch/con_fix.png';
import HighRewardCrownIcon50 from '../../assets/icons/punch/lucky.png';
import FreePunchGloveIcon from '../../assets/icons/punch/benefit-punch.png';
import BurningCardIcon from '../../assets/icons/punch/benefit-burning.png';

const AD_ICON_URL = '/assets/icons/punch/ad-rest.png';

const PRIMARY_AD_BUTTON_CLASS =
  "flex h-[54px] w-[300px] cursor-pointer items-center justify-center gap-[10px] rounded-[8px] border-0 bg-[#1E1E1E] py-4 text-center font-['Pretendard'] text-[16px] font-bold leading-[1.4] text-white disabled:cursor-not-allowed disabled:opacity-55";

const SECONDARY_BUTTON_CLASS =
  "w-[300px] cursor-pointer rounded-[8px] border-0 bg-[#E2E2E2] py-4 text-center font-['Pretendard'] text-[14px] font-bold leading-[1.4] text-gray03 disabled:cursor-not-allowed disabled:opacity-55";

function PunchAdButton({ label, onClick, isLoading = false }) {
  return (
    <button type="button" onClick={onClick} disabled={isLoading} className={PRIMARY_AD_BUTTON_CLASS}>
      {!isLoading ? <img src={HighRewardAdIcon} alt="" aria-hidden="true" className="h-4 w-4 object-contain" /> : null}
      <span>{isLoading ? '로딩 중' : label}</span>
    </button>
  );
}

function PunchPopupFrame({
  iconSrc,
  iconEmoji,
  title,
  description,
  children,
  cardHeight = 242,
  cardTop = 26,
  onClose,
  iconInsideCard = false,
  isCloseDisabled = false,
}) {
  if (iconInsideCard) {
    return (
      <div className="relative w-[320px]">
        <div
          className="relative w-[320px] rounded-2xl bg-gradient-to-t from-white from-[34.503%] to-[#DFD7FF] to-[91.708%] shadow-[0px_5px_16px_0px_rgba(0,0,0,0.1)]"
          style={{ marginTop: `${cardTop}px`, minHeight: `${cardHeight}px` }}
        >
          {onClose ? (
            <button
              type="button"
              aria-label="팝업 닫기"
              onClick={onClose}
              disabled={isCloseDisabled}
              className="absolute right-5 top-5 z-10 flex h-6 w-6 cursor-pointer items-center justify-center border-0 bg-transparent p-0 disabled:cursor-not-allowed disabled:opacity-50"
            >
              <img src={HighRewardCloseXIcon} alt="" aria-hidden="true" className="h-4 w-4 object-contain" />
            </button>
          ) : null}
          <div className="relative flex w-full flex-col items-center gap-[30px] px-[10px] pb-4 pt-6">
            <div className="flex w-[300px] flex-col items-center gap-5">
              {iconSrc ? <img src={iconSrc} alt="" className="h-20 w-20 object-cover" /> : null}
              {!iconSrc && iconEmoji ? (
                <div className="flex h-20 w-20 items-center justify-center text-[56px] leading-none">{iconEmoji}</div>
              ) : null}
              <h3 className="m-0 text-center font-['Pretendard'] text-[22px] font-extrabold leading-[1.4] text-gray05">
                {title}
              </h3>
              <p className="m-0 whitespace-pre-line text-center font-['Pretendard'] text-sm font-bold leading-[1.4] text-gray03">
                {description}
              </p>
            </div>
            {children}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="relative w-[320px]">
      <div
        className="absolute left-0 w-[320px] rounded-2xl bg-gradient-to-t from-white from-[34.503%] to-[#DFD7FF] to-[91.708%] shadow-[0px_5px_16px_0px_rgba(0,0,0,0.1)]"
        style={{ top: `${cardTop}px`, height: `${cardHeight}px` }}
      />
      {onClose ? (
        <button
          type="button"
          aria-label="팝업 닫기"
          onClick={onClose}
          disabled={isCloseDisabled}
          className="absolute right-5 top-[calc(26px+20px)] z-10 flex h-6 w-6 cursor-pointer items-center justify-center border-0 bg-transparent p-0 disabled:cursor-not-allowed disabled:opacity-50"
        >
          <img src={HighRewardCloseXIcon} alt="" aria-hidden="true" className="h-4 w-4 object-contain" />
        </button>
      ) : null}
      <div className="relative flex w-full flex-col items-center gap-[30px] px-[10px] pb-4 pt-0">
        <div className="flex w-[300px] flex-col items-center gap-5">
          {iconSrc ? <img src={iconSrc} alt="" className="h-20 w-20 object-cover" /> : null}
          {!iconSrc && iconEmoji ? (
            <div className="flex h-20 w-20 items-center justify-center text-[56px] leading-none">{iconEmoji}</div>
          ) : null}
          <h3 className="m-0 text-center font-['Pretendard'] text-[22px] font-extrabold leading-[1.4] text-gray05">
            {title}
          </h3>
          <p className="m-0 whitespace-pre-line text-center font-['Pretendard'] text-sm font-bold leading-[1.4] text-gray03">
            {description}
          </p>
        </div>
        {children}
      </div>
    </div>
  );
}

export function PunchAdRestPopup({ onWatchAd, onSkip, isPrimaryAdLoading = false }) {
  return (
    <PunchPopupFrame
      iconSrc={AD_ICON_URL}
      title="광고 휴식"
      description="잠시 광고 보며 쉬고 2 P 받아가요"
      cardHeight={300}
      cardTop={29}
      iconInsideCard
    >
      <div className="flex w-[300px] flex-col items-center gap-[10px]">
        <PunchAdButton label="2 P 획득하기" onClick={onWatchAd} isLoading={isPrimaryAdLoading} />
        <button type="button" onClick={onSkip} disabled={isPrimaryAdLoading} className={SECONDARY_BUTTON_CLASS}>
          무시하고 플레이
        </button>
      </div>
    </PunchPopupFrame>
  );
}

export function PunchHighRewardPopup({ rewardPoint, onWatchAd, onSkip, isPrimaryAdLoading = false }) {
  const rewardTier = getHighRewardTier(rewardPoint);
  const rewardIconByTier = {
    [HIGH_REWARD_TIER.JACKPOT]: HighRewardCrownIcon150,
    [HIGH_REWARD_TIER.GREAT]: HighRewardCrownIcon100,
    [HIGH_REWARD_TIER.NICE]: HighRewardCrownIcon80,
    [HIGH_REWARD_TIER.BASIC]: HighRewardCrownIcon50,
  };
  const rewardTitleByTier = {
    [HIGH_REWARD_TIER.JACKPOT]: `완전 초대박 ${rewardPoint}P!!`,
    [HIGH_REWARD_TIER.GREAT]: `잭팟, 대박이야 ${rewardPoint}P!`,
    [HIGH_REWARD_TIER.NICE]: `잭팟, 나이스 ${rewardPoint}P!`,
    [HIGH_REWARD_TIER.BASIC]: `오 럭키~ ${rewardPoint}P!`,
  };
  const rewardIcon = rewardIconByTier[rewardTier] ?? HighRewardCrownIcon50;
  const rewardTitle = rewardTitleByTier[rewardTier] ?? `오 럭키~ ${rewardPoint}P!`;
  return (
    <PunchPopupFrame
      iconSrc={rewardIcon}
      title={rewardTitle}
      description="광고 시청 마무리시 포인트 지급"
      cardHeight={300}
      cardTop={26}
      onClose={onSkip}
      isCloseDisabled={isPrimaryAdLoading}
      iconInsideCard
    >
      <PunchAdButton label="광고보기" onClick={onWatchAd} isLoading={isPrimaryAdLoading} />
    </PunchPopupFrame>
  );
}

export function PunchPointShortagePopup({ adAvailable, onWatchAd, onCharge, onClose, isPrimaryAdLoading = false }) {
  const primaryLabel = adAvailable ? '광고 보기' : '충전하기';
  const isAdButtonLoading = adAvailable && isPrimaryAdLoading;

  return (
    <PunchPopupFrame
      iconEmoji="😿"
      title="포인트가 부족해요!"
      description={adAvailable ? '광고 한 번 보고 1회 무료 펀치' : '포인트를 충전해주세요'}
      cardHeight={300}
      cardTop={29}
      iconInsideCard
      onClose={onClose}
      isCloseDisabled={isAdButtonLoading}
    >
      <div className="flex w-[300px] flex-col items-center gap-[10px]">
        {adAvailable ? (
          <PunchAdButton label={primaryLabel} onClick={onWatchAd} isLoading={isAdButtonLoading} />
        ) : (
          <button type="button" onClick={onCharge} className={PRIMARY_AD_BUTTON_CLASS}>
            <span>{primaryLabel}</span>
          </button>
        )}
        <button type="button" onClick={onClose} disabled={isAdButtonLoading} className={SECONDARY_BUTTON_CLASS}>
          닫기
        </button>
      </div>
    </PunchPopupFrame>
  );
}

export function PunchFreePunchAdPopup({ onWatchAd, onClose, isPrimaryAdLoading = false }) {
  return (
    <PunchPopupFrame
      iconSrc={FreePunchGloveIcon}
      title="무료펀치"
      description="광고 시청 후 무료펀치 1회가 준비돼요"
      cardHeight={235}
      cardTop={29}
      onClose={onClose}
      isCloseDisabled={isPrimaryAdLoading}
    >
      <PunchAdButton label="광고보기" onClick={onWatchAd} isLoading={isPrimaryAdLoading} />
    </PunchPopupFrame>
  );
}

export function PunchBurningStartPopup({ onWatchAd, onClose, isPrimaryAdLoading = false }) {
  return (
    <PunchPopupFrame
      iconSrc={BurningCardIcon}
      title="버닝타임 시작"
      description={'광고를 시청하면\n30초간 광고가 스킵되고 3P로 펀치해요'}
      cardHeight={260}
      cardTop={29}
      onClose={onClose}
      isCloseDisabled={isPrimaryAdLoading}
    >
      <PunchAdButton label="광고 보고 시작하기" onClick={onWatchAd} isLoading={isPrimaryAdLoading} />
    </PunchPopupFrame>
  );
}

export function PunchBurningEndPopup({ onWatchAd, onSkip, isPrimaryAdLoading = false }) {
  return (
    <PunchPopupFrame
      iconSrc={AD_ICON_URL}
      title="추가 포인트 기회"
      description={'버닝타임 종료!\n광고를 보면 2P를 받을 수 있어요'}
      cardHeight={320}
      cardTop={29}
    >
      <div className="flex w-[300px] flex-col items-center gap-[10px]">
        <PunchAdButton label="2 P 획득하기" onClick={onWatchAd} isLoading={isPrimaryAdLoading} />
        <button type="button" onClick={onSkip} disabled={isPrimaryAdLoading} className={SECONDARY_BUTTON_CLASS}>
          무시하고 플레이
        </button>
      </div>
    </PunchPopupFrame>
  );
}
